function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoworking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.84,255.6s-3,4.79-2.17,8.73,8.16,21.1,13.6,36.86,4.35,32.92,4.35,38-.27,8.72,3.54,10.69,9.79.85,11.42-2.81,2.72-27-.27-41.09-13.6-38.83-16.32-44.46S165.91,248,155.84,255.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 335.23,
    width: 58.98,
    height: 15.73,
    rx: 4.24,
    transform: "matrix(1, -0.03, 0.03, 1, -10.72, 6.89)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.22,330.14c7.91-69.74-30.38-162.42-70.08-200.69-71.66-69.1-131.2-55.74-177.5-31s-52.92,107.38-84.9,144.76-50.16,87.66-1.65,137.72,87.65,24.62,138.37,21.44,118,21.82,154.35.09C416.22,387.3,428.73,361,432.22,330.14Z",
    style: {
      fill: "#0063F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,330.14c7.91-69.74-30.38-162.42-70.08-200.69-71.66-69.1-131.2-55.74-177.5-31s-52.92,107.38-84.9,144.76-50.16,87.66-1.65,137.72,87.65,24.62,138.37,21.44,118,21.82,154.35.09C416.22,387.3,428.73,361,432.22,330.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.64,192.75c-6.37-3.48-9.27-.58-11.59-3.48s6.38-10.43-11-18c0,0-1.16-16.23-24.92-16.81s-17.38,16.23-23.76,20.28-8.11-2.31-14.49,1.74-3.47,12.17-8.69,13.33-12.17-5.21-18.54-1.16-6.38,7.54-9.27,7.54-8.7-2.32-12.17,0-7.54,5.21-7.54,5.21H255.28S257,196.23,250.64,192.75Z",
    style: {
      fill: "#0063F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,146.49c-2.58-1.42-3.76-.24-4.7-1.42s2.59-4.23-4.47-7.29c0,0-.47-6.58-10.11-6.82s-7.06,6.59-9.64,8.23-3.3-.94-5.88.71-1.41,4.94-3.53,5.41-4.94-2.12-7.53-.47-2.58,3.06-3.76,3.06-3.53-.94-4.94,0-3.05,2.11-3.05,2.11H347S347.69,147.9,345.1,146.49Z",
    style: {
      fill: "#0063F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,268.57c-2.59-1.41-3.76-.23-4.7-1.41s2.58-4.23-4.47-7.29c0,0-.47-6.59-10.11-6.82s-7.06,6.59-9.65,8.23-3.29-.94-5.88.71-1.41,4.94-3.52,5.41-4.94-2.12-7.53-.47S213,270,211.83,270s-3.53-.94-4.94,0-3.06,2.12-3.06,2.12h59.5S264,270,261.45,268.57Z",
    style: {
      fill: "#0063F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.64,192.75c-6.37-3.48-9.27-.58-11.59-3.48s6.38-10.43-11-18c0,0-1.16-16.23-24.92-16.81s-17.38,16.23-23.76,20.28-8.11-2.31-14.49,1.74-3.47,12.17-8.69,13.33-12.17-5.21-18.54-1.16-6.38,7.54-9.27,7.54-8.7-2.32-12.17,0-7.54,5.21-7.54,5.21H255.28S257,196.23,250.64,192.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.1,146.49c-2.58-1.42-3.76-.24-4.7-1.42s2.59-4.23-4.47-7.29c0,0-.47-6.58-10.11-6.82s-7.06,6.59-9.64,8.23-3.3-.94-5.88.71-1.41,4.94-3.53,5.41-4.94-2.12-7.53-.47-2.58,3.06-3.76,3.06-3.53-.94-4.94,0-3.05,2.11-3.05,2.11H347S347.69,147.9,345.1,146.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.45,268.57c-2.59-1.41-3.76-.23-4.7-1.41s2.58-4.23-4.47-7.29c0,0-.47-6.59-10.11-6.82s-7.06,6.59-9.65,8.23-3.29-.94-5.88.71-1.41,4.94-3.52,5.41-4.94-2.12-7.53-.47S213,270,211.83,270s-3.53-.94-4.94,0-3.06,2.12-3.06,2.12h59.5S264,270,261.45,268.57Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.67,
    y: 283.37,
    width: 372,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 285.37,
    x2: 355,
    y2: 123.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187,
    y1: 285.37,
    x2: 187,
    y2: 98.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 193.16,
    x2: 428.24,
    y2: 193.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,104.58h10a3.32,3.32,0,0,1,3.32,3.32V118a0,0,0,0,1,0,0H248.65a0,0,0,0,1,0,0V107.9A3.32,3.32,0,0,1,252,104.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.75,
    cy: 130.45,
    r: 7.75,
    style: {
      fill: "#0063F7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.75,
    cy: 130.45,
    r: 7.75,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.92 130.82 224.01 130.82 248.73 117.36 265.14 117.36 289.92 130.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.57,
    y: 79.49,
    width: 2.79,
    height: 26.94,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.41,218.4a12.23,12.23,0,0,0,3.6.4s-.55-1.67-.6-1.77c-.56-1.18-2.33-3.11-3.77-2.92a1.72,1.72,0,0,0-1.38,2.16A3.59,3.59,0,0,0,367.41,218.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.85,209.71c-1.44-.16-3.16,1.83-3.69,3,0,.11-.57,1.79-.55,1.79h0l-.87,1c-.57.7-1.2,1.49-1.83,2.39a34.36,34.36,0,0,0-1.9,3,23.41,23.41,0,0,0-1.62,3.65.09.09,0,0,1,0,0c0-.43,0-1.62,0-1.71-.17-1.29-1.25-3.68-2.68-3.94a1.71,1.71,0,0,0-2,1.61,3.56,3.56,0,0,0,1.38,2.7,12,12,0,0,0,3.26,1.49,30.79,30.79,0,0,0-1,4c-.14.78-.25,1.57-.36,2.36,0-.37,0-.7,0-.75-.16-1.28-1.24-3.68-2.67-3.94a1.73,1.73,0,0,0-2,1.62,3.61,3.61,0,0,0,1.38,2.69,11.32,11.32,0,0,0,3.17,1.46l-.12.91c-.17,1.46-.34,2.92-.55,4.34-.07.51-.16,1-.25,1.49,0-.33,0-.6,0-.64-.17-1.29-1.25-3.68-2.68-3.95a1.72,1.72,0,0,0-2,1.62,3.61,3.61,0,0,0,1.38,2.7,11,11,0,0,0,3.07,1.42c-.1.51-.21,1-.34,1.49-.09.33-.16.65-.27,1s-.2.64-.31,1c-.21.6-.44,1.22-.66,1.8-.16.4-.31.79-.47,1.17.08-.5.21-1.48.21-1.56a6.65,6.65,0,0,0-.89-3.25,2.34,2.34,0,0,0,0-.38,1.72,1.72,0,0,0-2.1-1.46c-1.41.37-2.3,2.84-2.36,4.14,0,.07,0,.91.08,1.43-.07-.3-.13-.6-.21-.91-.15-.62-.31-1.24-.49-1.9-.09-.32-.19-.64-.29-1s-.23-.65-.34-1c-.28-.76-.6-1.52-.93-2.27a11.13,11.13,0,0,0,3.24-1.22,3.61,3.61,0,0,0,1.58-2.58,1.73,1.73,0,0,0-1.86-1.76c-1.45.16-2.7,2.46-3,3.73,0,.08-.1,1-.13,1.53-.21-.45-.42-.91-.64-1.36-.65-1.3-1.34-2.6-2-3.89l-.62-1.2a12,12,0,0,0,3.36-1.24,3.6,3.6,0,0,0,1.58-2.58A1.72,1.72,0,0,0,378,226c-1.45.15-2.7,2.46-3,3.73,0,.09-.14,1.44-.16,1.78-.45-.88-.9-1.75-1.3-2.64a30.64,30.64,0,0,1-1.42-3.66,12.22,12.22,0,0,0,3.38-1.25,3.63,3.63,0,0,0,1.58-2.58,1.73,1.73,0,0,0-1.86-1.77c-1.45.16-2.7,2.46-3,3.74,0,.1-.15,1.54-.15,1.81a1.43,1.43,0,0,0-.08-.22,23.23,23.23,0,0,1-.73-3.87c-.08-.73-.12-1.42-.14-2.1a11.15,11.15,0,0,0,3.41-.86,3.61,3.61,0,0,0,1.86-2.39,1.73,1.73,0,0,0-1.66-2c-1.45,0-2.95,2.15-3.35,3.39,0,.07-.17.77-.27,1.29,0-.31,0-.62,0-.91,0-1.1.07-2.11.14-3,0-.51.09-1,.14-1.39a11.6,11.6,0,0,0,2.62-2.33,3.57,3.57,0,0,0,.54-3,1.73,1.73,0,0,0-2.37-1c-1.29.67-1.63,3.27-1.42,4.55,0,.11.51,1.81.53,1.79h0c-.06.41-.11.85-.17,1.33-.08.89-.18,1.9-.2,3a31.11,31.11,0,0,0,.08,3.57,23.55,23.55,0,0,0,.66,3.93l0,.05c-.23-.36-.9-1.34-1-1.41-.85-1-3.07-2.38-4.41-1.81a1.72,1.72,0,0,0-.77,2.44,3.62,3.62,0,0,0,2.64,1.49,12.4,12.4,0,0,0,3.55-.56,29.26,29.26,0,0,0,1.38,3.82c.31.73.65,1.45,1,2.17-.21-.31-.4-.58-.43-.61-.85-1-3.07-2.38-4.41-1.81a1.72,1.72,0,0,0-.76,2.44,3.6,3.6,0,0,0,2.64,1.49,11.62,11.62,0,0,0,3.44-.53l.41.82c.66,1.31,1.32,2.62,1.93,3.93.22.45.42.91.61,1.37-.18-.27-.34-.49-.37-.52-.85-1-3.07-2.38-4.4-1.82a1.73,1.73,0,0,0-.77,2.45,3.61,3.61,0,0,0,2.64,1.48,10.84,10.84,0,0,0,3.35-.5c.19.48.38,1,.54,1.43.1.32.22.62.31,1l.27,1c.15.62.3,1.26.44,1.87.09.43.17.83.25,1.24-.21-.46-.64-1.35-.68-1.42-.69-1.1-2.67-2.82-4.08-2.46a1.72,1.72,0,0,0-1.13,2.3,3.6,3.6,0,0,0,2.39,1.87,11.78,11.78,0,0,0,3.56,0c.14.68.26,1.33.37,2,.38,2.16.62,4,.76,5.24,0,.22,0,.43.07.62h-4.38l1.6,31.18h7.46l1.6-31.18h-4.08l.09-.19c.56-1.17,1.34-2.84,2.18-4.89.26-.65.53-1.35.81-2.06a11.92,11.92,0,0,0,3.55.27,3.61,3.61,0,0,0,2.52-1.68,1.73,1.73,0,0,0-.95-2.38c-1.38-.46-3.49,1.1-4.26,2.15,0,.06-.46.78-.72,1.24.11-.29.22-.57.33-.88.22-.6.42-1.2.64-1.85.1-.32.19-.64.29-1s.17-.67.26-1c.19-.79.34-1.6.47-2.41a11.4,11.4,0,0,0,3.38.77,3.59,3.59,0,0,0,2.74-1.28,1.73,1.73,0,0,0-.58-2.5c-1.29-.66-3.61.56-4.53,1.48-.06.06-.64.79-1,1.2.08-.49.16-1,.22-1.48.18-1.45.32-2.91.46-4.37,0-.45.09-.89.14-1.34a12.11,12.11,0,0,0,3.49.82,3.62,3.62,0,0,0,2.74-1.29,1.72,1.72,0,0,0-.58-2.49c-1.29-.67-3.61.56-4.53,1.48-.07.07-.91,1.12-1.11,1.4.1-1,.21-2,.36-2.92a30.31,30.31,0,0,1,.84-3.84,12.23,12.23,0,0,0,3.51.82,3.59,3.59,0,0,0,2.74-1.28,1.73,1.73,0,0,0-.58-2.5c-1.29-.66-3.61.56-4.53,1.48-.07.07-1,1.21-1.13,1.42a1.8,1.8,0,0,0,.06-.22,22.09,22.09,0,0,1,1.52-3.63c.33-.65.69-1.25,1-1.83a11.53,11.53,0,0,0,3.32,1.17,3.61,3.61,0,0,0,2.87-1,1.73,1.73,0,0,0-.3-2.55c-1.21-.8-3.65.16-4.67,1l-.93.93.49-.77c.61-.91,1.22-1.71,1.77-2.42.32-.4.61-.75.89-1.08a11.61,11.61,0,0,0,3.47-.49,3.62,3.62,0,0,0,2.09-2.19A1.72,1.72,0,0,0,400.85,209.71Zm-16,38.85c-.87,2-1.68,3.66-2.25,4.8l-.32.62h-.1c0-.23-.06-.47-.1-.74-.17-1.28-.45-3.11-.88-5.28-.14-.69-.29-1.42-.46-2.17a21.23,21.23,0,0,0,2-.93,12.87,12.87,0,0,0,2.89,1.87C385.35,247.36,385.1,248,384.84,248.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.23,219s.47-1.69.48-1.81c.18-1.28-.23-3.87-1.54-4.51a1.73,1.73,0,0,0-2.34,1,3.61,3.61,0,0,0,.62,3A12.27,12.27,0,0,0,393.23,219Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "179.97 246.42 171.9 270.21 164.04 323.95 134.9 396.45 144.06 396.45 186.44 327.23 199.5 284.48 217.8 329.16 221.03 396.99 230.7 396.99 236.64 324.86 224.79 269.05 222.27 257.2 179.97 246.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.83,183.17s-14.74-2.46-28.14.44-31.23,8.6-44.3,17.86A58.53,58.53,0,0,0,153,208l9.77,7.33s15.81-4.3,21-4.34a74.88,74.88,0,0,0,9-.81L180,246.42s-.68,8.71,8.71,12.51,26.82,5.9,33.82.51c3.69-2.83,21.28-48.35,21.28-48.35s5.15,26.76,6.71,30.78a26.59,26.59,0,0,0,4.7,7.37l9.82-7.37s-5.38-26.32-7.39-35S248,184.51,232.83,183.17Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "208.26 208.18 192.85 210.19 204.91 213.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.81,186.07s5.37,8.94.45,18.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.78,
    y1: 211.09,
    x2: 254.05,
    y2: 209.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.22,
    y1: 211.98,
    x2: 257.85,
    y2: 213.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.71,180.49s-7.14,2.23-8.93,4.46S221,208.41,221,208.41l9.16-2,7.82,6s-.45-12.73-1.79-21.45S231.71,180.49,231.71,180.49Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.06,174.9s-5.8,8.27-7.14,10-.45,11.4.22,14.75a44.15,44.15,0,0,0,2,6.7l9.16-9.61s-3.58-4.24-2.91-9.6S240,176,239.76,174.46,235.06,174.9,235.06,174.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84,178.7s-4,9.83-3.13,13.4,10.28,11.84,14.75,10.5,5.13-9.61,5.13-9.61,2,.9,2.68.45.9-6,.9-6a42.68,42.68,0,0,0,2.9-3.57,20.88,20.88,0,0,0,1.56-2.91s7.38-.22,6.71-6.92-13.18-16.31-22.12-16.31S231.94,168,231.94,171.11,234.84,178.7,234.84,178.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.46,185.83a7.84,7.84,0,0,0-5.33-2.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.53,187l-.8,1.35s-1.88.49-2.59-.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,174c-.67-6.7-13.18-16.31-22.12-16.31S231.94,168,231.94,171.11s2.9,7.59,2.9,7.59-4,9.83-3.13,13.4,10.28,11.84,14.75,10.5c3.52-1.06,4.68-6.41,5-8.63-3.18-3.43-7.93.21-10.6,1-2.9.89-5.81-3.13-5.81-5.37s2.91-8.26,3.58-9.38,4.24-.22,6.25-.44-.89-3.58-.44-5.59,7.14,4.92,9.82,6.48a6,6,0,0,0,5.36.22S267,180.71,266.34,174ZM246.9,195.9c3.35-.45,3.35.89,3.35.89-1.21,2.83-1.78,2.24-2.9,1.79S243.55,196.35,246.9,195.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,180.71s.67-4.47-2-4.91-2.9,3.35-2.9,5.8,2.9,2.46,4.24,2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.05,168.21a4.78,4.78,0,0,0-1.37,1.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,176.65a23.25,23.25,0,0,1-8.56-6.31c-2.38-2.75-5.12-3.4-7.31-3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,177.87s-2-6.92-10.38-4.68",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,219.18s3-4.74,6.76-3.4a25,25,0,0,1,7.37,4.69l3.35-5.36s.67-5.58-5.36-8.48-9.38-.45-9.38-.45C151.57,206.61,148.68,217.89,151.13,219.18Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,237.4a35.52,35.52,0,0,0-9.83,4.47,11.59,11.59,0,0,0-4.69,6.7s5.14,5.58,6.25,5.58,9.61-9.38,10.5-10.27S265.91,237.4,265.91,237.4Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,262.64s-.22,3.13-1.12,3.8-4.91,0-4.91,0-2.68-3.8-1.57-5.36,3.13-1.12,4.47-.67A11,11,0,0,1,305.22,262.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,243.88,292,256.16l8.71,1.12s10.72,5.36,10.72,6.25-1.11,1.35-2,1.12-7.37-2.9-8.71-2.9-2.46.44-2.23,1.56,3.35,5.81,1.56,5.81-3.57-4.47-4.47-4.92a34.51,34.51,0,0,1-4-3.79s-20.55-4.25-25.24-4.92a17.19,17.19,0,0,1-7.37-2.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.05,396.45l2.87,4.11a13,13,0,0,0,4.66,4.07l5.56,2.87a1.14,1.14,0,0,1,.62,1h0a1.15,1.15,0,0,1-1.21,1.15c-5.22-.27-25.67-1.31-26.38-1.31s-1.09-1.09-.82-4.37,5.55-7.54,5.55-7.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,396.45l2.87,4.11a13,13,0,0,0,4.66,4.07l5.55,2.87a1.13,1.13,0,0,1,.63,1h0a1.15,1.15,0,0,1-1.21,1.15c-5.22-.27-25.67-1.31-26.38-1.31s-1.1-1.09-.82-4.37,5.55-7.54,5.55-7.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,255.6s-3,4.79-2.17,8.73,8.16,21.1,13.6,36.86,4.35,32.92,4.35,38-.27,8.72,3.54,10.69,9.79.85,11.42-2.81,2.72-27-.27-41.09-13.6-38.83-16.32-44.46S165.91,248,155.84,255.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.84,255.6s-3,4.79-2.17,8.73,8.16,21.1,13.6,36.86,4.35,32.92,4.35,38-.27,8.72,3.54,10.69,9.79.85,11.42-2.81,2.72-27-.27-41.09-13.6-38.83-16.32-44.46S165.91,248,155.84,255.6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,258.6s-3,4.79-2.17,8.73,8.16,21.1,13.6,36.86,4.35,32.92,4.35,38-.27,8.72,3.54,10.69,9.79.85,11.42-2.81,2.72-27-.27-41.09-13.6-38.83-16.32-44.46S161.91,251,151.84,258.6Z",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,255.6s-3,4.79-2.17,8.73,8.16,21.1,13.6,36.86,4.35,32.92,4.35,38-.27,8.72,3.54,10.69,9.79.85,11.42-2.81,2.72-27-.27-41.09-13.6-38.83-16.32-44.46S165.91,248,155.84,255.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,216a37.64,37.64,0,0,0,2.21,15.42c1.75,4.78,11.08,19.86,11.08,19.86s-7.82,2.91-10.05,4.92-4.92,8.48-3.58,8.71,6.26-5.36,7.38-5.81,7.59-.89,7.59-.89-1.34,1.83-2.38,3.52a7.74,7.74,0,0,0-1.19,2.51c0,1.11,1.56.89,2.45-.9s3.58-1.56,4.47-5.58a19.46,19.46,0,0,0-.45-8.49l-3.91-28.81S161.21,212.37,151.64,216Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,264.92s3.1-6.67,6.51-7.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.13,261.09a24.89,24.89,0,0,1,5.11-5.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.84,
    y: 346.59,
    width: 3.65,
    height: 35.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.3 383.2 216.3 377.27 207.03 377.27 207.03 383.25 169.96 397.49 169.96 404.51 172.49 404.51 172.49 399.17 211.8 390.87 250.07 399.17 250.07 404.51 252.53 404.51 252.53 397.49 216.3 383.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.54,
    y: 346.59,
    width: 18.25,
    height: 11.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.03,
    cy: 404.79,
    r: 3.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.72,404.79a1.69,1.69,0,1,0-1.69,1.69A1.69,1.69,0,0,0,167.72,404.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.74,
    cy: 404.79,
    r: 3.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.74,
    cy: 404.79,
    r: 1.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.35 405.35 210.26 405.35 208.72 384.29 214.9 384.29 213.35 405.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.12,
    y: 400.86,
    width: 3.09,
    height: 8.71,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,286.49s24.67-3.88,27-4.27,6.8,2.72,8.93,4.27,11.85,7.38,10.69,7.77-5.05-1.16-7.58-2.13-4.47-1.75-4.47-1.75a31.35,31.35,0,0,0,3.11,3.69c1,.78.59,1.36-2.13.19A13.32,13.32,0,0,1,253,289.6c-1-1.55-2.53-4.27-2.53-4.27s-21.36,8-24.86,9.13-8.94,1.16-8.74-2.53S223.3,286.49,223.3,286.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,286.49c-2.13-1.55-6.6-4.66-8.93-4.27-1.24.21-8.74,1.39-15.53,2.46l.87,6.15c7-2.56,14.85-5.5,14.85-5.5s1.56,2.72,2.53,4.27a13.32,13.32,0,0,0,5.83,4.66c2.72,1.17,3.1.59,2.13-.19a31.35,31.35,0,0,1-3.11-3.69s1.95.78,4.47,1.75,6.41,2.52,7.58,2.13S261.37,288.05,259.23,286.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.59,
    y1: 288.63,
    x2: 269.92,
    y2: 294.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.57,225.29s5.44-3.5,4.47-7.38-17.09-9.72-24.86-8-10.3,9.71-12.44,15.54-10.87,30.89-10.87,30.89,6.41,7.18,14.57,3.49,15.54-23.69,19.23-27.77S242.57,225.29,242.57,225.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,212.69s3.46,2.44,4.48,4.68-.21,3.46-.21,3.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,214.93a48.31,48.31,0,0,1-14.46,10.38c-8.35,3.67-14.05,6.72-16.7,9.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.72,240.23a29.93,29.93,0,0,0-1.14,3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,215.8a53.73,53.73,0,0,1-5.76,4.83c-5.66,4.16-12.68,9.68-16.83,17.23",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,212.08a13.23,13.23,0,0,1-1.14,1.52",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.66,245.68s-14,6-18.07,8.16-4.85,6.41-4.85,10.1S195,295.41,195,295.41H217.9s4.08-8.16,7-10.88,5.24-8.15,4.08-11.85-2.34-5.63-2.34-9.32-.77-8.35-3.69-11.27S218.49,244.52,212.66,245.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.92,351.39c.5,2.54,2.53,5.69,3.53,8.1,2,4.89,5.68,12.64,7.9,17.45,3.15,6.86,5.51,15.74,5.08,16.34a14.91,14.91,0,0,0-1.47,4.85c0,1.21.84,11.5.84,11.5h1.48l1.05-6.06s3.36.21,4.41,1.21,2.31,3.23,4.2,4.24,10.5,1.41,10.5,1.41,1.47-.8-.42-2.42-4.83-3.83-6.51-6.25-6.51-8.27-6.51-8.27S274.07,333.58,273.23,331s-3.57-8.27-6.09-8.87S256,320.66,256,320.66L255.59,331s2-.4,4.29,4.24C261.3,338,259.47,343.92,260.92,351.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3,404.83c-5,1.66-10.17-3.3-12.45-5.9a13.78,13.78,0,0,0-5.27-3.56,11.16,11.16,0,0,0-.62,2.76c0,1.21.84,11.5.84,11.5h1.48l1.05-6.06s3.36.21,4.41,1.21,2.31,3.23,4.2,4.24,10.5,1.41,10.5,1.41,1.47-.8-.42-2.42C297,407.12,295.6,406,294.3,404.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,318.14s9.15,2.56,8.58,4.53-14.31,43.1-19.46,52.75-7.06,17.33-6.49,19.69,5.35,10.05,6.87,11.23,5.34,3.15,4.77,3.35a83.13,83.13,0,0,1-12.21,0c-.94-.11-6.29-6.5-7.25-6.9l-1-.39v7.09H239l-.76-10.83a16.52,16.52,0,0,1,2.86-5.52c1.91-2.16,3.81-4.53,5.53-10.43s8-36.21,9-42.32A48,48,0,0,1,259,329Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.71,406.34a9.09,9.09,0,0,1-1.36-1.55A9.39,9.39,0,0,1,251,404c-2.48-1.38-4.77-4.53-6.87-6.9a13.12,13.12,0,0,0-3.94-2.75,18.3,18.3,0,0,0-2,4.33l.76,10.83h2.1V402.4l1,.39c1,.4,6.31,6.79,7.25,6.9a83.13,83.13,0,0,0,12.21,0C262.05,409.49,258.24,407.52,256.71,406.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,295.41S193.23,317,193,324s5.63,13.79,13.6,14.57S262,332.9,262,332.9l7.77-14.18s-22.92-5.83-30.69-8-15.15-3.5-15.15-3.5l-6-11.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59,257.14l3.89,6.8s-1.36-7.18-2.14-9.71-2.91-1.75-2.91-.39a19,19,0,0,0,.8,4",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.12,233.46l-6.7,10.72,5.81,13.62s3.57-8.26,5.36-10.27,4.91-4.92,4.91-4.92-5.58-6.7-6-8.48S222.57,231.67,222.12,233.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.21 242.19 210.72 245.68 216.93 263.56 221.59 257.14 214.21 242.19",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.65,270.74s10.1,22.73,12.24,27.39,6.8,5.63,11.07,5.63S247,303,247,303s14.76.58,17.29,0,6.6-4.08,7.38-4.08,5.05,3.88,6,3.88,1.56-.58.78-1.94-3.89-7.38-6-7.57-11.27,5.82-11.27,5.82-15.15-2.13-23.11-4.27-20.4-7-20.4-7-5.05-9.33-7.19-15-2.52-13.21-6.41-16.32-8.74.39-8.74.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,293.28c-2.14-.2-11.27,5.82-11.27,5.82s-7.59-1.07-14.85-2.45l.19,6.35H247s14.76.58,17.29,0,6.6-4.08,7.38-4.08,5.05,3.88,6,3.88,1.56-.58.78-1.94S274.62,293.47,272.49,293.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.1,296.77s5.24,3.69,6.41,5.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.68,
    y1: 295.02,
    x2: 277.34,
    y2: 298.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,220.72a62.17,62.17,0,0,1,1.48,6.54c.22,2-1.34,3.13-.67,4.24s2.39,4.62,1.5,5.06a6.87,6.87,0,0,1-2.46.45s-4.09,7.61-5,9-7.15-1.78-10.06-3.12-3.12-7.82-3.12-7.82l-.23-4.47S237.54,225.41,242,220.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,228.09c2.9-3.52,2.86.37,2.86.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,232.26c-.26.82-.73,1.4-1.06,1.3s-.38-.85-.13-1.67.73-1.4,1.06-1.29S240.36,231.45,240.11,232.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,232.34s-1.57-5.59-3.35-4.47-2.68,5.36-.9,7.6,4.69.89,4.69.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 335.23,
    width: 58.98,
    height: 15.73,
    rx: 4.24,
    transform: "matrix(1, -0.03, 0.03, 1, -10.72, 6.89)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-61)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 335.23,
    width: 58.98,
    height: 15.73,
    rx: 4.24,
    transform: "matrix(1, -0.03, 0.03, 1, -10.72, 6.89)",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 339.41,
    width: 58.98,
    height: 15.73,
    rx: 4.24,
    transform: "translate(-10.85 6.89) rotate(-1.81)",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 335.23,
    width: 58.98,
    height: 15.73,
    rx: 4.24,
    transform: "matrix(1, -0.03, 0.03, 1, -10.72, 6.89)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.48,344.41a2,2,0,0,1-.78-.16,2,2,0,0,1-1.1-2.66c3.28-7.9,7-22,3.19-26.2-.9-.62-6.32-1.94-35.54.74l-2.12.19c-2,.16-3.79,2.76-4.24,3.66a2,2,0,1,1-3.64-1.83c.28-.56,2.9-5.53,7.56-5.89l2.07-.18c31.13-2.86,37.1-1.42,38.91.55,6.86,7.49-1.46,28.19-2.43,30.53A2,2,0,0,1,222.48,344.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.43,
    y: 305.04,
    width: 160.3,
    height: 11.23,
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.7,
    y: 300.51,
    width: 34.9,
    height: 7.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.39,
    y: 293.33,
    width: 34.9,
    height: 5.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.8,
    y: 287.7,
    width: 34.9,
    height: 5.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.5,
    y: 298.82,
    width: 34.9,
    height: 9.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.43,
    y: 305.29,
    width: 160.3,
    height: 5.35,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,409.67h0a1.12,1.12,0,0,1-1.12-1.11l-.73-103.27h3.69l-.73,103.27A1.11,1.11,0,0,1,241.31,409.67Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.76,409.67h0a1.11,1.11,0,0,1-1.11-1.11l-.73-103.27h3.69l-.73,103.27A1.13,1.13,0,0,1,399.76,409.67Z",
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.1,303.45H309.82a1.25,1.25,0,0,1,0-2.5H327.1a3,3,0,0,0,2.19-1,3,3,0,0,0,.66-2.78l-6.13-22a1.25,1.25,0,0,1,.87-1.54,1.26,1.26,0,0,1,1.54.87l6.13,22a5.46,5.46,0,0,1-5.26,6.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 245.93,
    width: 3.94,
    height: 50.94,
    transform: "translate(34.58 -36.16) rotate(6.84)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,246.34a76.28,76.28,0,0,1-6.07,50.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.93,300.53a4.62,4.62,0,0,1-2.08-.55,5.43,5.43,0,0,1-3-5.18,3.42,3.42,0,0,1,1.38-2.58c1.73-1.24,4.35-.64,4.65-.56a1,1,0,0,1-.49,1.94,4.46,4.46,0,0,0-3,.24,1.38,1.38,0,0,0-.54,1.12,3.42,3.42,0,0,0,1.91,3.25,1.76,1.76,0,0,0,1.8.12,1,1,0,0,1,1.28,1.54A3,3,0,0,1,291.93,300.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1,302.24c-1.3,1.08-5.46,1.08-6.76,0-2.32-1.93-2.25-11.86-2.25-11.86h11.26S303.42,300.31,301.1,302.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.49,
    y: 302.84,
    width: 168.18,
    height: 4.66,
    style: {
      fill: "#0063F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.17,
    y: 408.89,
    width: 369.52,
    height: 6.69,
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoworking);
export default __webpack_public_path__ + "static/media/coworking.50d9540b68187837a05361ac411439a1.svg";
export { ForwardRef as ReactComponent };